import React, { useEffect, useState, useCallback } from "react";
import {
  Sensors,
  SortBy,
  Filters,
  FiltersSelected,
  Stats,
} from "@usereactify/search";

import { FilterList } from "@app/scripts/reactify/filters/FilterList";
import { FilterRange } from "@app/scripts/reactify/filters/FilterRange";
import { FilterSlider } from "@app/scripts/reactify/filters/FilterSlider";
import { FilterSelected } from "@app/scripts/reactify/filters/FilterSelected";
import { FilterStats } from "@app/scripts/reactify/filters/FilterStats";
import { FilterSortBy } from "@app/scripts/reactify/filters/FilterSort";

import { ResultsList } from "../../results/ResultsList";

export const MainSearch: React.FC = (props) => {
  const [isMobile, setIsMobile] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");

  const handleWindowDimensionChange = useCallback(() => {
    setIsMobile(window.innerWidth < 1024);
  }, []);

  useEffect(() => {
    setIsMobile(window.innerWidth < 1024);

    window.addEventListener("resize", handleWindowDimensionChange);
    return () => window.removeEventListener("resize", handleWindowDimensionChange);
  }, [handleWindowDimensionChange]);

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const query = params.get("q")?.replace(/\+/g, " ") || "Search";
    setSearchQuery(query);
  }, []);

  const openFilterDrawer = () => {
    const drawer = document.querySelector(".search__container .search__left");
    drawer?.classList.add("mobile-open");
  };

  const closeFilterDrawer = () => {
    const drawer = document.querySelector(".search__container .search__left");
    drawer?.classList.remove("mobile-open");
  };

  return (
    <>
    <h1 className="search-heading">
      SEARCH RESULTS FOR "{searchQuery.toUpperCase()}"
    </h1>

      <div className="search__container search-page">
        <Sensors />

        <div className="search__left">
          <div className="search__overlay"></div>
          <div className="search__filters fade-in">
            <div className="search__heading">
              Filter and sort
              {isMobile && (
                <span onClick={closeFilterDrawer}>
                  <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
                    <path
                      fillRule="evenodd"
                      clipRule="evenodd"
                      d="M12.5848 0L14 1.41517L8.414 7L14 12.5848L12.5848 14L7 8.414L1.41517 14L0 12.5848L5.586 7L0 1.41517L1.41517 0L7 5.586L12.5848 0Z"
                      fill="black"
                    />
                  </svg>
                </span>
              )}
            </div>
            <div className="filter__container">
              <SortBy render={FilterSortBy} />
              <Filters
                renderFilterList={FilterList}
                renderFilterRange={FilterRange}
                renderFilterSlider={FilterSlider}
                showEmptyFilters={false}
              />
            </div>
          </div>
        </div>

        <div className="search__right">
          <div className="search__right-top">
            {isMobile && (
              <div className="filter__drawer-button" onClick={openFilterDrawer}>
                <span>
                  <svg xmlns="http://www.w3.org/2000/svg" width="15" height="14" viewBox="0 0 15 14" fill="none">
                    <path
                      d="M8.61039 9.4375H7.85065V0.90625C7.85065 0.682812 7.62273 0.5 7.34416 0.5H6.83766C6.55909 0.5 6.33117 0.682812 6.33117 0.90625V9.4375H5.57143C5.29286 9.4375 5.06494 9.62031 5.06494 9.84375V10.6562C5.06494 10.8797 5.29286 11.0625 5.57143 11.0625H6.33117V13.0938C6.33117 13.3172 6.55909 13.5 6.83766 13.5H7.34416C7.62273 13.5 7.85065 13.3172 7.85065 13.0938V11.0625H8.61039C8.88896 11.0625 9.11688 10.8797 9.11688 10.6562V9.84375C9.11688 9.62031 8.88896 9.4375 8.61039 9.4375ZM3.54545 2.9375H2.78571V0.90625C2.78571 0.682812 2.55779 0.5 2.27922 0.5H1.77273C1.49416 0.5 1.26623 0.682812 1.26623 0.90625V2.9375H0.506494C0.227922 2.9375 0 3.12031 0 3.34375V4.15625C0 4.37969 0.227922 4.5625 0.506494 4.5625H1.26623V13.0938C1.26623 13.3172 1.49416 13.5 1.77273 13.5H2.27922C2.55779 13.5 2.78571 13.3172 2.78571 13.0938V4.5625H3.54545C3.82403 4.5625 4.05195 4.37969 4.05195 4.15625V3.34375C4.05195 3.12031 3.82403 2.9375 3.54545 2.9375ZM13.6753 6.1875H12.9156V0.90625C12.9156 0.682812 12.6877 0.5 12.4091 0.5H11.9026C11.624 0.5 11.3961 0.682812 11.3961 0.90625V6.1875H10.6364C10.3578 6.1875 10.1299 6.37031 10.1299 6.59375V7.40625C10.1299 7.62969 10.3578 7.8125 10.6364 7.8125H11.3961V13.0938C11.3961 13.3172 11.624 13.5 11.9026 13.5H12.4091C12.6877 13.5 12.9156 13.3172 12.9156 13.0938V7.8125H13.6753C13.9539 7.8125 14.1818 7.62969 14.1818 7.40625V6.59375C14.1818 6.37031 13.9539 6.1875 13.6753 6.1875Z"
                      fill="black"
                    />
                  </svg>
                </span>
                <span>Filter and sort</span>
              </div>
            )}
            <div className="filter__selected">
              <FiltersSelected render={FilterSelected} />
            </div>
            <div className="filter__stats">
              <Stats render={FilterStats} />
            </div>
          </div>
          <div className="search__results">
            <ResultsList />
          </div>
        </div>
      </div>
    </>
  );
};
